export default __webpack_public_path__ + "static/main4-af9c0dec6b87dada70e774a31be3d38f.jpg";